export const KIMI_K3_OPENROUTER_MODEL_ID = "moonshotai/kimi-k3";
export const KIMI_K3_MODEL_REF = "openrouter/moonshotai/kimi-k3";

export function isKimiK3OpenRouterModelRef(
  modelRef: string | null | undefined,
): boolean {
  return modelRef?.trim() === KIMI_K3_MODEL_REF;
}
